import { enhanceGoogleImageResolution } from "@/utils/enhanceGoogleImageResolution";

type UriType = string | null | undefined | { name: string };

const useImage = () => {
  const url = "https://webservice.ceedow.world";
  const noImage = "profile.webp";

  const getUri = (uri: UriType): string => {
    if (!uri) return noImage;

    if (typeof uri === "string") {
      if (uri.startsWith("https")) {
        const httpsUri = uri.startsWith("/") ? uri.substring(1) : uri;

        // Check if it's a Google profile image and enhance resolution
        if (isGoogleImage(httpsUri)) {
          return enhanceGoogleImageResolution(httpsUri);
        }

        return httpsUri;
      } else {
        return `${url}/images/${uri}`;
      }
    }
    return noImage;
  };

  // Check if the URL is from Google's profile image service
  const isGoogleImage = (url: string): boolean => {
    return (
      url.includes("googleusercontent.com") ||
      url.includes("ggpht.com") ||
      url.includes("google.com") ||
      url.includes("lh3.googleusercontent.com") ||
      url.includes("lh4.googleusercontent.com") ||
      url.includes("lh5.googleusercontent.com") ||
      url.includes("lh6.googleusercontent.com")
    );
  };

  return {
    getUri,
    noImage,
  };
};

export default useImage;
